module.exports = __webpack_public_path__ + "img/person_search_opsz24B.adcd15bb.svg";